// src/components/Modal.jsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function Modal({ title, children, onClose, className = '', bodyClassName = '' }) {
  useEffect(() => {
    const handleEsc = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`bg-[#1e293b] text-white rounded-lg shadow-lg w-full max-w-4xl p-6 relative ${className}`.trim()}>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >×</button>
        {title && <h2 className="text-2xl mb-4 sticky top-0 bg-[#1e293b] pr-10">{title}</h2>}
        <div className={bodyClassName}>{children}</div>
      </div>
    </div>,
    document.body
  );
}
